import Vue from 'vue';
import Vuex from 'vuex';
import { install as VuexORMInstall, Database } from 'vuex-orm';

import { DEFAULT_LOCALE } from '@/constants';
import { retrieveLocale } from '@/i18n/utils';

// Plugins
import i18nPlugin from '@/store/plugins/i18n';
import timezonePlugin from '@/store/plugins/timezone';
import timePlugin from '@/store/plugins/time';

// Global
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// Models
import App from './modules/app/model';
import AppMembership from './modules/appMembership/model';
import Category from './modules/category/model';
import Comment from './modules/comment/model';
import Company from './modules/company/model';
import Invoice from './modules/invoice/model';
import Payroll from './modules/payroll/model';
import Log from './modules/log/model';
import AppPackage from './modules/package/model';
import Policy from './modules/policy/model';
import Profile from './modules/profile/model';
import Pto from './modules/pto/model';
import PtoAvailability from './modules/ptoAvailability/model';
import Role from './modules/role/model';
import Schedule from './modules/schedule/model';
import TimeLog from './modules/timeLog/model';
import Timesheet from './modules/timesheet/model';
import User from './modules/user/model';
import UserMembership from './modules/userMembership/model';
import Version from './modules/version/model';

// Modules
import apps from './modules/app/index';
import appMemberships from './modules/appMembership/index';
import categories from './modules/category/index';
import comments from './modules/comment/index';
import companies from './modules/company/index';
import invoices from './modules/invoice/index';
import payrolls from './modules/payroll/index';
import logs from './modules/log/index';
import packages from './modules/package/index';
import policies from './modules/policy/index';
import profiles from './modules/profile/index';
import ptos from './modules/pto/index';
import ptoAvailabilities from './modules/ptoAvailability/index';
import roles from './modules/role/index';
import schedules from './modules/schedule/index';
import timeLogs from './modules/timeLog/index';
import timesheets from './modules/timesheet/index';
import users from './modules/user/index';
import userMemberships from './modules/userMembership/index';
import versions from './modules/version/index';

Vue.use(Vuex);

// Database
const database = new Database();

database.register(App, apps);
database.register(AppMembership, appMemberships);
database.register(Category, categories);
database.register(Comment, comments);
database.register(Company, companies);
database.register(Invoice, invoices);
database.register(Payroll, payrolls);
database.register(Log, logs);
database.register(AppPackage, packages);
database.register(Policy, policies);
database.register(Profile, profiles);
database.register(Pto, ptos);
database.register(PtoAvailability, ptoAvailabilities);
database.register(Role, roles);
database.register(Schedule, schedules);
database.register(TimeLog, timeLogs);
database.register(Timesheet, timesheets);
database.register(User, users);
database.register(UserMembership, userMemberships);
database.register(Version, versions);

const state = {
  locale: retrieveLocale() || DEFAULT_LOCALE,
  timezone: null,
  entities: {},
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  plugins: [i18nPlugin, timezonePlugin, timePlugin, VuexORMInstall(database)],
});



// WEBPACK FOOTER //
// ./src/store/index.js